import PropTypes from 'prop-types';
import React from 'react';
import Modal from "react-bootstrap/Modal";

const CalculationInfo = (props) => {
    const { showModal } = props;
    return (
        <Modal
            {...props}
            size="lg"
            className="modalDeleteWrapper"
            centered
            backdrop="static"
            show={showModal}
        >
            <Modal.Header closeButton>
                <div className="">
                    <text className="modal-m-text"> Total Rent Formula</text>
                </div>
            </Modal.Header>
            <div className="modal_container_rate_card pt-3">
                <div className="row mb-15 fontFix">
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="rent-calculation-info p-1">
                    <strong>Total Rent</strong> = [<em>fixed rate (seller-based rate)</em> x <em>Frequency</em>] + 
                    [<em>variable rate (calculated by volume per unit of all products)</em> x <em>Frequency</em> x <em>Billable Days</em>]

                    <h5 className="mt-4">Fixed Rent</h5>
                    <p>
                        A baseline charge applied for the selected storage period.<br />
                        <strong>Example:</strong> Fixed Rent = $5,000 per month
                    </p>

                    <h5 className="mt-4">Variable Rent (Formula-Based)</h5>
                    <p>
                        Charged in addition to fixed rent, based on the inventory’s volume or floor space.
                    </p>
                    <p>
                        <strong>Formula:</strong> Variable Rent = Rate Value × Billable Units × Billable Days
                    </p>

                    <h5 className="mt-4">Rate Card Explanation</h5>
                    <p>
                        Rate Cards define pre-agreed charges by warehouse and seller. Pre-filled values can be overridden with admin permissions.
                    </p>

                    <h5 className="mt-4">Rate Basis</h5>
                    <p>
                        Daily, Weekly, Bimonthly, Monthly, Quarterly, or Annually. Auto-converted when the unit basis differs (e.g., CBM → CFT).
                    </p>

                    <h5 className="mt-4">Unit Basis</h5>
                    <p>
                        Default CBM (Cubic Meter). <br />
                        <strong>Conversion:</strong> 1 m³ = 35.31447 ft³.
                    </p>

                    <h5 className="mt-4">Example Calculation</h5>
                    <p>
                        <strong>Rate Value:</strong> $100 / CBM / Day <br />
                        <strong>Inventory:</strong> 10 CBM <br />
                        <strong>Period:</strong> 30 Days
                    </p>
                    <p>
                        <strong>Variable Rent:</strong> 100 × 10 × 30 = $30,000
                    </p>

                    <h5 className="mt-4">Return Items (Without Dimensions)</h5>
                    <p>
                        When item dimensions are unavailable, rent is calculated using size buckets with fixed tariffs defined in the Return Tariff Table.
                    </p>

                    <ul className="pl-3">
                        <li><strong>Small (S):</strong> $50 per unit per day</li>
                        <li><strong>Medium (M):</strong> $100 per unit per day</li>
                        <li><strong>Large (L):</strong> $150 per unit per day</li>
                        <li><strong>Oversize:</strong> $250 per unit per day</li>
                    </ul>

                    <p className="mt-3">
                        <strong>Final Formula:</strong> Total Rent = Fixed Rent + Variable Rent
                    </p>
                    </div>
            </div>
        </div>
            </div>
        </Modal>
    );
}

CalculationInfo.propTypes = {
    showModal: PropTypes.bool.isRequired,
};
 
export default CalculationInfo;